import { getRichTextStyle } from "cms/theme/helpers";
import { BodyTextVariant } from "cms/theme/theme";
import Styled from "styled-components";

export interface ContainerProps {
  $variant: BodyTextVariant;
}

export const Container = Styled.div<ContainerProps>`
  ${(props) => getRichTextStyle(props.theme, props.$variant)};
`;

export const LinkWrapper = Styled.span`
  a { 
    text-decoration: none;
    font-weight: 700;
    color: inherit;
    transition: all 0.3s ease 0s;
  }

  a:hover, a:focus, a:active {
    color: ${(props) => props.theme.colors.blue500};
  }
`;
